import { Button, Flex, Text } from "@minervaproject/fds";
import { useState } from "react";

import { BreakoutDetails } from "./breakout_details";
import { NewBreakoutForm } from "./new_breakout_form";

import { useAppSelector } from "hooks/redux_hooks";
import { BreakoutType } from "shared/types";
import { classroomSelectors } from "store";

function NonActiveBreakout() {
  const breakouts = Object.values(useAppSelector(classroomSelectors.selectBreakouts()));
  const [selectedBreakout, setSelectedBreakout] = useState<BreakoutType | null>(null);

  const hideCallback = () => setSelectedBreakout(null);

  return selectedBreakout ? (
    <BreakoutDetails breakout={selectedBreakout} hideCallback={hideCallback} />
  ) : (
    <Flex direction="column" none>
      <NewBreakoutForm breakouts={breakouts} />
      <Text className="body-l" kind="h2" mt={5} mb={4}>
        Available Breakouts
      </Text>
      {breakouts.map((breakout) => (
        <Button
          key={breakout.id}
          className="mb1 flex-none truncate"
          kind="classroom-secondary"
          data-testid="available-breakout-button"
          onClick={() => setSelectedBreakout(breakout)}
        >
          {breakout.title}
        </Button>
      ))}
    </Flex>
  );
}

export { NonActiveBreakout };
